import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/work_schedules/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
